import { ApiService } from './api.service';
import { Observable } from 'rxjs/internal/Observable';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';

@Injectable({
    providedIn: 'root'
  })



    export class ProfileDataService
    {
            constructor(private api: ApiService) { }

                //private baseUrlx: any = appConfig.settings.apiServer.baseUrl;
                private controller = 'User';
                private userPreferencesController = 'UserPreferences'
                private groupController = "Group";
                private getMethod = 'get';
                baseUrl: string = environment.profileServiceEndPoint;


                public getAllUsers(includeInactive: boolean) : Observable<any>
                {
                    return this.api.get(`${this.baseUrl}/${this.controller}/getall?includeInactive=${includeInactive}`);
                }

                public getUserPreferences(userId: string) : Observable<any>
                {
                  return this.api.get(`${this.baseUrl}/${this.userPreferencesController}?userid=${userId}`);
                }

                 public updateUserPreferences(userId: string, userPreferences: any) : Observable<any>
                {
                  return this.api.put(`${this.baseUrl}/${this.userPreferencesController}?userid=${userId}`, userPreferences);
                }

                public getUserProfile(userId: string): Observable<any>
                {
                  return this.api.get(`${this.baseUrl}/${this.controller}/UserProfile?userid=${userId}`);
                }

                public getTeams() : Observable<any>
                {
                    return this.api.get(`${this.baseUrl}/${this.groupController}/teams`);
                }

                public getApproverGroups() : Observable<any>
                {
                    return this.api.get(`${this.baseUrl}/${this.groupController}/approverGroups`);
                }

                public getUsersByGroup(groupNames: string[]): Observable<any>
                {
                  let groupQuery: string ='';
                  groupNames.forEach((groupName) => { groupQuery = `${groupQuery}groups=${encodeURIComponent(groupName)}&` });

                  return this.api.get(`${this.baseUrl}/${this.groupController}/GroupUsers?${groupQuery}`);
                }



    }

